import { useTranslation } from 'react-i18next';
import { FeaturesAuthLoginForm } from '@/features/auth';
import { LanguageSwitcher } from '@/shared/ui/feedback/LanguageSwitcher';

export const WidgetsLoginMain = () => {
  const { t } = useTranslation();
  return (
    <div className="relative flex min-h-screen w-full items-center justify-center bg-gradient-to-br from-sidebar via-sidebar to-brand-900 p-5">
      <div className="absolute right-5 top-5">
        <LanguageSwitcher variant="pills" />
      </div>
      <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-elev">
        <div className="flex flex-col items-center gap-6 p-8 sm:p-10">
          <h1 className="text-2xl font-bold text-ink">{t('login.title')}</h1>
          <div className="w-full">
            <FeaturesAuthLoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};
